var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{attrs:{"id":'a'+_vm.slide._id,"width":_vm.canvasWidth,"height":_vm.canvasHeight},on:{"mousemove":_vm.canvasMove}})
}
var staticRenderFns = []

export { render, staticRenderFns }